/**
 * Fonte única dos segmentos de rota das Configurações do Sistema (`/configuracoes/**`).
 * Consumido pelos `*-routes.ts` de cada sub-módulo e pelo menu do `configuracoes-content` — renomear
 * um caminho passa a ser um único lugar. As rotas de Usuários ficam em `configuracoes-usuario.constants.ts`.
 */
export const CONFIGURACOES_ROUTES = {
    ROOT: 'configuracoes',
    CONTABILIDADE: 'contabilidade',
    REFIS: 'refis',
    INDICADORES: 'indicadores',
    GERAIS: {
        ROOT: 'gerais',
        EMAIL: 'email',
        SERVICOS: 'servicos',
        MODULOS: 'modulos'
    },
    ARRECADACAO: {
        ROOT: 'arrecadacao',
        ANUIDADES: 'anuidades',
        ANUIDADES_NOVO: 'anuidades/novo',
        ANUIDADES_DETALHE: 'anuidades/:id',
        EMAIL: 'email',
        BANCOS: 'bancos-contas-convenios'
    },
    REGISTRO: {
        ROOT: 'registro',
        ESTRUTURAS: 'estruturas',
        ESTRUTURAS_DETALHE: 'estruturas/:id',
        FUNCIONARIOS: 'funcionarios'
    },
    COMISSOES: {
        ROOT: 'comissoes'
    },
    DIVIDA_ATIVA: {
        ROOT: 'divida-ativa',
        DADOS_GERAIS: 'dados-gerais',
        ASSINANTES: 'assinantes',
        DOCUMENTOS: 'documentos',
        ENTIDADES: 'entidades'
    }
} as const;
